// extracted by mini-css-extract-plugin
export default {"helpText":"X46IVq"};